module.exports = __webpack_public_path__ + "static/media/friend-mihail.422a323f.jpg";